var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMistralWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 805,
    height: 182,
    viewBox: "0 0 805 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 26,
    width: 26,
    height: 26,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 52,
    width: 52,
    height: 26,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 78,
    width: 130,
    height: 26,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 104,
    width: 26,
    height: 26,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 104,
    width: 26,
    height: 26,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 104,
    width: 26,
    height: 26,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 130,
    width: 78,
    height: 26,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 130,
    width: 78,
    height: 26,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 52,
    width: 52,
    height: 26,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 26,
    width: 26,
    height: 26,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M326.82 127.083H326.527L290.28 26H260V156H280.247V54.3723H280.383L316.674 155.637L316.81 156H335.633L372.06 54.3723H372.196V156H392.262V26H362.705L326.82 127.083Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M428.238 61.1038H407.991V156.006H428.238V61.1038Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M429.504 26H406.884V47.2482H429.504V26Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M507.58 105.46C502.767 103.328 496.394 101.31 488.621 99.4956L484.417 98.5885C479.243 97.5 475.175 96.5023 472.35 95.5952C469.594 94.7108 467.266 93.4636 465.436 91.8762C463.673 90.3342 462.814 88.2933 462.814 85.6401C462.814 81.8077 464.441 78.9958 467.808 77.0909C471.221 75.1407 475.491 74.1429 480.463 74.1429C492.53 74.1429 499.445 79.0865 501.591 89.223L501.682 89.6765H521.929L521.816 89.0189C519.85 78.066 514.946 70.1291 507.263 65.4124C499.625 60.741 490.858 58.3826 481.209 58.3826C470.949 58.3826 462.023 60.6956 454.679 65.231C447.245 69.8343 443.494 76.8868 443.494 86.1843C443.494 94.7561 446.702 101.242 453.03 105.482C459.267 109.655 467.537 112.875 477.638 115.075C484.169 116.412 489.185 117.569 492.53 118.544C495.829 119.497 498.586 120.902 500.688 122.717C502.767 124.508 503.761 126.798 503.761 129.678C503.761 133.896 502.021 137.094 498.45 139.429C494.857 141.788 490.089 142.99 484.282 142.99C478.813 142.99 473.751 141.584 469.187 138.772C464.667 136.005 461.346 131.107 459.334 124.213L459.221 123.805H439.155L439.313 124.485C442.002 136.89 447.629 145.802 456.058 150.995C464.419 156.142 474 158.75 484.485 158.75C494.97 158.75 504.303 156.324 511.828 151.539C519.443 146.709 523.285 139.271 523.285 129.497C523.285 123.306 521.861 118.249 519.082 114.44C516.302 110.653 512.438 107.659 507.557 105.482L507.58 105.46Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M565.091 32.395H544.844V61.0812H526.45V78.4743H544.663V137.116C544.663 144.328 546.38 149.339 549.793 152.015C553.16 154.646 558.719 155.984 566.357 155.984H587.869V137.479H568.368C565.905 137.479 564.752 136.323 564.752 133.851V78.4969H587.892V61.1038H565.136V32.395H565.091Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M627.936 65.1402C623.937 67.7481 621.451 71.5351 620.502 76.4559L620.434 61.1038H600.368V156.006H620.615V105.369C620.615 97.1145 622.242 90.4929 625.428 85.6627C628.569 80.9233 634.241 78.5195 642.263 78.5195H656.296V61.1264H642.082C636.772 61.1264 632.004 62.487 627.936 65.1402Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M730.07 65.2763C722.546 60.6729 713.71 58.3599 703.677 58.3599C693.643 58.3599 684.695 60.6049 676.628 65.0042C668.493 69.4488 663.431 77.2723 661.578 88.2479L661.465 88.9055H681.712L681.802 88.452C682.865 83.4177 685.35 79.8121 689.26 77.7712C693.237 75.6849 697.892 74.6418 703.112 74.6418C707.857 74.6418 712.173 75.5942 715.97 77.4991C719.676 79.3586 721.483 82.3066 721.483 86.5018C721.483 89.1549 720.693 91.1278 719.043 92.5565C717.348 94.0305 715.156 95.1416 712.512 95.9126C709.823 96.6836 705.891 97.5227 700.829 98.3617L696.83 99.0874C689.169 100.425 682.684 102.013 677.532 103.759C672.312 105.55 667.702 108.589 663.815 112.784C659.906 117.025 657.94 122.921 657.94 130.359C657.94 139.021 661.126 146.006 667.431 151.085C673.69 156.142 681.667 158.705 691.09 158.705C698.073 158.705 704.309 157.231 709.665 154.351C714.93 151.493 719.043 146.935 721.868 140.813H722.026V155.983H741.55V89.6085C741.55 78.1113 737.686 69.925 730.07 65.2763ZM693.869 143.352C689.757 143.352 686.119 142.128 683.023 139.724C679.927 137.32 678.413 134.032 678.413 129.656C678.413 124.962 680.198 121.583 683.881 119.36C687.633 117.093 692.807 115.211 699.27 113.759L704.196 112.852C708.58 111.99 712.105 111.129 714.727 110.267C717.325 109.428 719.517 108.135 721.257 106.457H721.551V113.011C721.551 119.587 720.218 125.211 717.619 129.724C715.021 134.236 711.563 137.683 707.36 139.928C703.157 142.196 698.615 143.33 693.869 143.33V143.352Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M777.461 26H757.395V156H777.461V26Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMistralWhite);
export default __webpack_public_path__ + "static/media/logo_mistral_white.ef0da2a8c83f51b6f9fac7ceeb44f8fc.svg";
export { ForwardRef as ReactComponent };